<template>
<div class="chapter">
<div class="inner_page">
<div id="fm1">
<p style="margin-top: 40%;"> </p>
<p class="image">
<img alt="" class="figure" id="F1" src="images/9780802195005_0001.jpg"/>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780802195005_logo.vue?5db07e01